import React from 'react';
import { Table, tbody, tr, td } from 'react-bootstrap';
import '../DataCollectionGroupPanel.css';
import { convertToExponential, convertToFixed, wavelengthToEnergy } from '../../../../helpers/NumericTransformationsHelper.js';

export default class SecondSectionPanel extends React.Component {  
    getRow(key, value){
            return  <tr>
                         <td  xs={5} md={5} className="parameterKey" >{key}</td>
                        <td  xs={7} md={7} className="parameterValue" >{value}</td>
                    </tr>;
    }              
    render() {         
         
        return <Table>   
                    <tbody>                
                    {this.getRow("Res. (corner)",  convertToFixed(this.props.datacollectiongroup.resolution, 2) + "  Å (" + convertToFixed(this.props.datacollectiongroup.cornerResolution, 2)  + "  Å )")}
                    {this.getRow("En. (Wave.)",  convertToFixed(wavelengthToEnergy(this.props.datacollectiongroup.wavelength), 3) + " KeV (" + convertToFixed(this.props.datacollectiongroup.wavelength, 4) + ")")}
                    {this.getRow(this.props.datacollectiongroup.rotationAxis + " range",  convertToFixed(this.props.datacollectiongroup.axisRange,2) + "°")}
                    {this.getRow(this.props.datacollectiongroup.rotationAxis + " start (total)",  convertToFixed(this.props.datacollectiongroup.axisStart,2) + "° (" +  convertToFixed(this.props.datacollectiongroup.axisEnd - this.props.datacollectiongroup.axisStart,2)  +"°)")}
                    {this.getRow("Exposure Time	",  this.props.datacollectiongroup.exposureTime + "s")}
                    {this.getRow("Flux start",  convertToExponential(this.props.datacollectiongroup.fluxStart) + " ph/sec"  )}
                    {this.getRow("Flux end",  convertToExponential(this.props.datacollectiongroup.fluxEnd) + " ph/sec"  )} 
                    </tbody>                 
            </Table>;
    }
}





// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SummaryDataCollectionGroup/SecondSectionPanel.js